// clusterPropertyParser.ts
import {
  AudioMessage_ClusterProperties,
  AudioMessage_ClusterPropertyValue,
} from "../generated/audio_message";

export type Primitive = string | number | boolean;
export type ParsedClusterProperties = Record<string, Primitive | Primitive[] | Record<string, Primitive> | Record<string, Primitive>[]>;

export function coercePropertyValue(
  v?: AudioMessage_ClusterPropertyValue
): Primitive | Primitive[] | Record<string, Primitive> | Record<string, Primitive>[] | undefined {
  if (!v) return undefined;

  switch (v.value?.oneofKind) {
    case "strValue":
      return v.value.strValue;
    case "intValue":
      return Number(v.value.intValue);
    case "floatValue":
      return v.value.floatValue;
    case "boolValue":
      return v.value.boolValue;
    case "dictValue": {
      const obj: Record<string, Primitive> = {};
      for (const p of v.value.dictValue.properties ?? []) {
        const subVal = coercePropertyValue(p.value);
        if (
          subVal !== undefined &&
          (typeof subVal === "string" ||
            typeof subVal === "number" ||
            typeof subVal === "boolean")
        ) {
          obj[p.property] = subVal;
        }
      }
      return obj;
    }
    case "listValue": {
      const arr: Array<Primitive | Record<string, Primitive>> = [];
      for (const item of v.value.listValue.values ?? []) {
        const val = coercePropertyValue(item);
        if (val !== undefined) {
          arr.push(val as any);
        }
      }
      return arr as any;
    }
    default:
      return undefined;
  }
}

export function parseClusterProperties(
  props?: AudioMessage_ClusterProperties
): ParsedClusterProperties {
  const map: ParsedClusterProperties = {};
  if (!props?.properties) return map;

  for (const p of props.properties) {
    const val = coercePropertyValue(p.value);
    if (p.property && val !== undefined) {
      map[p.property] = val;
    }
  }

  return map;
}